import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsGlobalSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() => {
		if (!__SERVER__) {
			return import(
				/* webpackChunkName: "async-assets-global-settings-entrypoint" */ './index.tsx'
			);
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve({ default: () => null }) as unknown as Promise<
			typeof import('./index.tsx')
		>;
	}),
	getPreloadProps: () => ({}),
});
